import { routes } from "routes/routes";

import { ReactComponent as HomeIcon } from "assets/images/sideMenu/home-icon.svg";
import { ReactComponent as InvoicesIcon } from "assets/images/sideMenu/invoices-icon.svg";
import { ReactComponent as AccountsIcon } from "assets/images/sideMenu/accounts-icon.svg";

import { ReactComponent as IntegrationIcon } from "assets/images/sideMenu/integration-icon.svg";
import { ReactComponent as ApiTokenIcon } from "assets/images/sideMenu/api-key-icon.svg";

import { ReactComponent as ProfileIcon } from "assets/images/sideMenu/profile-icon.svg";
import { ReactComponent as SubscriptionsIcon } from "assets/images/sideMenu/subscriptions-icon.svg";

import { ReactComponent as SettingsIcon } from "assets/images/sideMenu/settings-icon.svg";

import { ReactComponent as SupportIcon } from "assets/images/sideMenu/support-icon.svg";
import { ReactComponent as FaqIcon } from "assets/images/sideMenu/faq-icon.svg";
import { ReactComponent as LogoutIcon } from "assets/images/sideMenu/logout-icon.svg";

import { featureFlag } from "shared/constants/posthog";

import { MenuItemI } from "../SideMenu/SideMenuItem";

export const menuItems: MenuItemI[][] = [
  [
    { route: routes.home, icon: HomeIcon, name: "Головна" },
    { route: routes.invoices, icon: InvoicesIcon, name: "Мої посилання" },
    { route: routes.accounts, icon: AccountsIcon, name: "Мої реквізити" },
  ],
  [
    {
      route: routes.integrations,
      icon: IntegrationIcon,
      name: "Інтеграції",
      featureFlag: featureFlag.bank_integration_feature_enabled,
    },
    { route: routes.apiToken, icon: ApiTokenIcon, name: "API Токен" },
  ],
  [
    { route: routes.profile, icon: ProfileIcon, name: "Мій профіль" },
    { route: routes.subscription, icon: SubscriptionsIcon, name: "Мій тариф" },
  ],
  [{ route: routes.settings, icon: SettingsIcon, name: "Налаштування" }],
  [
    { route: routes.support, icon: SupportIcon, name: "Служба підтримки" },
    { route: routes.faq, icon: FaqIcon, name: "Часті запитання" },
    { route: "logout", icon: LogoutIcon, name: "Вийти" },
  ],
];
